import { useStoreActions } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { QueryKeys } from '../queryKeys';
import { useQueryState } from '../useQueryState';
const EMPTY_ACTIVITY_LOG = [];
export const useActivityLog = function useActivityLog(relationshipId) {
    let { refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { ACTIVITY_LOG_V2 } = useFeatureFlags();
    const { data, isLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.ActivityLog,
            relationshipId,
            !!ACTIVITY_LOG_V2
        ],
        queryFn: ()=>ACTIVITY_LOG_V2 ? api.activityLog.get(relationshipId) : api.activityLog.getOld(relationshipId),
        enabled: !!relationshipId,
        refreshOnHookMount
    });
    return {
        activityLog: data !== null && data !== void 0 ? data : EMPTY_ACTIVITY_LOG,
        isLoading,
        error,
        refresh
    };
};
